import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import { OnlineStatus } from './Component/OnlineStatus';
import OfflineBanner from './Component/OfflineBanner';



// Home Components
import Home from './home/Home';
import Navbar from './home/Navbar';

// Syllabus
import Syllabus from './Books/Syllabus/Syllabus';
import SyllabusPhy from './Books/Syllabus/Subjects/SyllabusPhy';
import SyllabusChem from './Books/Syllabus/Subjects/SyllabusChe';
import SyllabusMath from './Books/Syllabus/Subjects/SyllabusMath';

// Quiz Components
import QuizStarting from './MockTest/QuizStarting';
import QuizDetailsPage from './MockTest/QuizDetailsPage';

import PageNotFound from './Pages/PageNotFound';

import QuizReStarting from './MockTest/QuizReStarting';

import Bottombar from './home/Bottombar';
import About from './Pages/About';
import Contact from './Pages/Contact';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import Footer from './home/Footer';
import PDFViewer from './Books/PDFViwer';
import MoreOptions from './home/MoreOptions';


import OnlineReadBook from './Books/OnlineReadBook';

import QuestionSolution from './Practics/QuestionSolution';

import ChapterWiseWeightage from './Pages/ChapterWiseWeightage/ChapterWiseWeightage';
import ChapterWiseWeightagePhysTopics from './Pages/ChapterWiseWeightage/subjects/ChapterWiseWeightagePhysTopics';
import ChapterWiseWeightageChemTopics from './Pages/ChapterWiseWeightage/subjects/ChapterWiseWeightageChemTopics';
import ChapterWiseWeightageMathTopics from './Pages/ChapterWiseWeightage/subjects/ChapterWiseWeightageMathTopics';

import StudyPlanner from './Pages/StudyPlanner';
import StudyTimeTable from './Pages/StudyTimeTable';

import PYQMockTest from './MockTest/PYQMockTest/PYQMockTestSubject';
import PYQMockTestYear from './MockTest/PYQMockTest/PYQMockTestYear';
import PYQMTStartDetails from './MockTest/PYQMTStartDetails';
import BookmarkedQuestions from './Practics/BookMarkedQuestions';
import BookmarkedPdfs from './Books/BookMarkedPdfs';


const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent = () => {
  const location = useLocation();

    const isOnline = OnlineStatus();


  return (
    <>
     

     {!isOnline && (<OfflineBanner />)}

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        <Navbar />}

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/pdfviewer') &&
        !location.pathname.startsWith('/onlinereadbook') &&
        !location.pathname.startsWith('/account-deletion') &&
        <Bottombar />}

      <Routes>
        {/* Public Routes */}
        <Route path='/' element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

      
        <Route path="/more-options" element={<MoreOptions />} />

        <Route path="/pdfviewer/:id" element={<PDFViewer />} />
        <Route path="/onlinereadbook/:type/:subject/:topic" element={<OnlineReadBook />} />
        <Route path="/question-solution/:id" element={<QuestionSolution />} />
        <Route path="/bookmarked-questions" element={<BookmarkedQuestions />} />
        <Route path="/bookmarked-pdfs" element={<BookmarkedPdfs />} />

        
       {/* PYQ Quiz Routes */}
        <Route path="/pyq-mock-test" element={<PYQMockTest />} />
        <Route path="/pyq-mock-test/:type/:subject/:subjectName" element={<PYQMockTestYear />} />

        <Route path="/quiz-starting/:quizId/:type/:subject/:subjectName" element={<QuizStarting />} />
        <Route path="/quiz-restarting/:quizId" element={<QuizReStarting />} />
        <Route path="/quiz-details/:quizId" element={<QuizDetailsPage />} />
        <Route path="/pyq-mock-test-start-details/:quizId/:type/:subject/:subjectName" element={<PYQMTStartDetails />} />
        
        {/* Syllabus Routes */}
        <Route path="/syllabus" element={<Syllabus />} />
        <Route path="/syllabus/physics" element={<SyllabusPhy />} />
        <Route path="/syllabus/chemistry" element={<SyllabusChem />} />
        <Route path="/syllabus/mathematics" element={<SyllabusMath />} />

        {/* Chapter Weightage Routes */}
        <Route path="/chapter-wise-weightage" element={<ChapterWiseWeightage />} />
        <Route path="/chapter-wise-weightage/physics" element={<ChapterWiseWeightagePhysTopics />} />
        <Route path="/chapter-wise-weightage/chemistry" element={<ChapterWiseWeightageChemTopics />} />
        <Route path="/chapter-wise-weightage/mathematics" element={<ChapterWiseWeightageMathTopics />} />

        {/* Study Planner Routes */}
        <Route path="/jee-main-study-planner" element={<StudyPlanner />} />
        <Route path="/jee-main-study-time-table" element={<StudyTimeTable />} />

        {/* 404 Route */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/onlinereadbook') &&
        <Footer />}
    </>
  );
};

export default App;